'use client';

import {
    useProductsTableController,
    type UseProductsTableControllerArgs,
} from '@/components/products-table/use-products-table-controller';
import { ProductsTableView } from '@/components/products-table/ProductsTableView';

type ProductsTableProps = UseProductsTableControllerArgs;

const ProductsTable = (props: ProductsTableProps) => {
    const controller = useProductsTableController(props);

    return <ProductsTableView {...controller} />;
};

export default ProductsTable;
